import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

import Close from "mdi-material-ui/Close";
import CloseCircleOutline from "mdi-material-ui/CloseCircleOutline";

const DialogModal = (props) => {
  const { open, handleClose, handleDelete } = props;
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      scroll="body"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            top: 10,
            right: 10,
            position: "absolute",
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CloseCircleOutline
            fontSize="small"
            sx={{ stroke: "#ffffff", strokeWidth: 1 }}
            style={{
              height: "16%",
              width: "16%",
              color: theme.palette.error.main,
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            py: 3,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            component="span"
            variant="body3"
            sx={{
              color: theme.palette.secondary.dark,
              fontWeight: 600,
              fontSize: "1.3rem !important",
            }}
          >
            Are you sure?
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            px: 10,
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="body"
            sx={{
              color: "text.secondary",
              fontSize: "1rem !important",
              textAlign: "center",
            }}
          >
            Do you really want to delete this record?
          </Typography>
          <Typography
            variant="body"
            sx={{
              color: "text.secondary",
              fontSize: "1rem !important",
              textAlign: "center",
            }}
          >
            This process cannot be undone.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        className="dialog-actions-dense"
        sx={{
          "&.MuiDialogActions-root": {
            alignItems: "center",
            justifyContent: "space-around",
            mb: 2,
            mx: 20,
          },
        }}
      >
        <Button
          type="reset"
          variant="contained"
          size="medium"
          onClick={handleClose}
          style={{ backgroundColor: theme.palette.text.disabled }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          size="medium"
          style={{ backgroundColor: theme.palette.error.main }}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DialogModal.defaultProps = {
  open: false,
  handleClose: () => {},
  handleDelete: () => {},
};

export default DialogModal;
